import { LatLngExpression } from "leaflet";
import { useState, useEffect } from "react";
export const usePosition = () => {
  const [position, setPosition] = useState<LatLngExpression | undefined>();
  const [error, setError] = useState<string | null>(null);

  const onChange = ({ coords }) => {
    setPosition([coords.latitude, coords.longitude]);
  };
  const onError = (error) => {
    setError(error.message);
  };
  useEffect(() => {
    const geo = navigator.geolocation;
    if (!geo) {
      setError("La géolocalisation n'est pas supportée");
      return;
    }
    geo.getCurrentPosition(onChange, onError, {
      enableHighAccuracy: true,
      timeout: 20000,
    });
  }, []);

  return { position, error };
};
